import script from "./AppSwiperMobileLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwiperMobileLoader.vue?vue&type=script&setup=true&lang=js"

import "./AppSwiperMobileLoader.vue?vue&type=style&index=0&id=3e1bfc64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1bfc64"]])

export default __exports__